import { Dispatch, SetStateAction } from "react";
import { UseFormReturn } from "react-hook-form";
import { CustomerBI as DashboardBI } from "~/application/types/entities/CustomerBI.type";
import { FilterCustomerBI, MultiValue } from "./DashboardCustomerPage";

export enum ItemService {
  ROAD = "road",
  AIRWAY = "airway",
  HOTEL = "hotel",
  VEHICLE = "vehicle",
}

export type Loading = {
  byUnit: boolean;
  costCenter: boolean;
  lastPurchase: boolean;
  airwayItem: boolean;
  hotelItem: boolean;
  roadItem: boolean;
  vehicleItem: boolean;
  byIssuer: boolean;
  leadTime: boolean;
  topRoutes: boolean;
  routeAnalysis: boolean;
  costCenterList: boolean;
  totalSpent: boolean;
  dataByItem: boolean;
  isLoadingProjects: boolean;
  isFetchingByPhases: boolean;
};

export type OnSelectMultiValuesProps = {
  value: string;
  field: "costCenter" | "issuers" | "items" | "startEndDate" | "projects" | "phases" | "units";
}

export interface CustomersBiContainerProps {
  dashboard?: DashboardBI;
  onCloseModal: Dispatch<SetStateAction<boolean>>;
  modalPrtalIsOpen: boolean;
  isLoading: Loading;
  filterData: UseFormReturn<FilterCustomerBI>;
  selectedMultiValues: MultiValue;
  onSelectMultiValues: ({ value, field }: OnSelectMultiValuesProps) => void;
  onSelectFilterType: (filterType: MultiValue["filterKeyType"]) => void;
  onRemoveItem: (item: string) => void;
  activeFilter: {
    type: string;
    value: string;
  };
  onSetActiveValue: ({ type, value }: { type: string; value: string }) => void;
  onSelectPeriodDate: (filterRangePeriod: MultiValue["filterRangePeriod"]) => void;
  handleSelectStartDate: (startEndDate: MultiValue["startEndDate"]) => void;
  onSearchCostCenter: (name: string) => void;
  onChangeFilter: (data: FilterCustomerBI) => void;
}
